import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../../services/core/authentication.service';
import { AppService } from '../../services/app.service';
import { ApiConnectionService } from '../../services/core/api-connection.service';
import { CollectionManagerService } from '../../services/core/collection-manager.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfigService } from '../../services/core/config.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-activate-account',
  templateUrl: './activate-account.component.html',
  styleUrls: ['./activate-account.component.scss']
})
export class ActivateAccountComponent implements OnInit {
  sections: any = [];
  currentUser;
  email;
  errors: any = {};
  errors2: any = {};
  errormessage = false;
  successmessage = false;
  changepassword = false;
  submitted = false;
  salesWebsite = ''

  constructor(
    public appService: AppService,
    public api: ApiConnectionService,
    private route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public collectionManager: CollectionManagerService,
    private ngxLoader: NgxUiLoaderService,
    private configService: ConfigService
  ) {
    let self = this;

    this.salesWebsite = configService.get('sales_website');

    self.authenticationService.data.subscribe(data => {
      if (Object.keys(data).length) {
        self.currentUser = data;
      } else {
        self.currentUser = false;
      }
    });

    self.appService.setDefaultAuthor();
    this.appService.setShowCheckRequestAlert();

    let email = this.route.snapshot.paramMap.get('email');
    this.email = email;
  }

  ngOnInit(): void {
    this.appService.navActive();
    this.appService.setPageTitle('Wachtwoord instellen');
    this.appService.setPageDescription('');

    this.appService.hideLoginModal();
    let self = this;
    this.ngxLoader.start();
    self.authenticationService.getCurrentUser().then(function (response) {
      self.ngxLoader.stop();
    });

    self.appService.setDefaultMeta();
  }

  save() {
    let self = this;
    self.errors = [];
    self.errors2 = {};
    self.successmessage = false;
    self.errormessage = false;

    this.ngxLoader.start();
    this.api.save('users/passwordRecovery', { email: self.email }).then((response) => {
      self.ngxLoader.stop();
      self.successmessage = true;
      self.submitted = true;
    }).catch(function (response) {
      self.ngxLoader.stop();
      self.errormessage = true;
      self.submitted = true;
      for (let error in response['error']['errors']) {
        try {
          self.errors2[error] = response['error']['errors'][error];
        } catch (e) {
        }
      }
    });
  }
}

